function initProductRichtextTruncate(root) {
  if (root.dataset.truncateInitialized === 'true') return;

  const clip = root.querySelector('.product-richtext-truncate__clip');
  const content = root.querySelector('.product-richtext-truncate__content');
  const btn = root.querySelector('.product-richtext-truncate__toggle');

  if (!clip || !content || !btn) return;

  root.dataset.truncateInitialized = 'true';

  const reduceMotion =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function afterTransition(el, fn) {
    if (reduceMotion) {
      fn();
      return;
    }

    let finished = false;
    const run = function () {
      if (finished) return;
      finished = true;
      el.removeEventListener('transitionend', onEnd);
      window.clearTimeout(fallback);
      fn();
    };
    const onEnd = function (event) {
      if (event.propertyName === 'height') run();
    };

    el.addEventListener('transitionend', onEnd);
    const fallback = window.setTimeout(run, 600);
  }

  function expand() {
    if (reduceMotion) {
      root.classList.add('product-richtext-block--truncate-expanded');
      btn.setAttribute('aria-expanded', 'true');
      clip.style.height = '';
      return;
    }

    const startHeight = clip.offsetHeight;
    clip.style.height = `${startHeight}px`;
    root.classList.add('product-richtext-block--truncate-expanded');
    btn.setAttribute('aria-expanded', 'true');

    const endHeight = content.scrollHeight;
    void clip.offsetHeight;
    clip.style.height = `${endHeight}px`;

    afterTransition(clip, function () {
      clip.style.height = '';
    });
  }

  function collapse() {
    btn.setAttribute('aria-expanded', 'false');

    if (reduceMotion) {
      root.classList.remove('product-richtext-block--truncate-expanded');
      clip.style.height = '';
      return;
    }

    const startHeight = clip.offsetHeight;
    clip.style.height = `${startHeight}px`;
    void clip.offsetHeight;
    root.classList.remove('product-richtext-block--truncate-expanded');

    const endHeight = content.offsetHeight;
    clip.style.height = `${endHeight}px`;

    afterTransition(clip, function () {
      clip.style.height = '';
    });
  }

  function measure() {
    root.classList.remove('product-richtext-block--truncate-expanded', 'product-richtext-block--truncate-no-overflow');
    btn.setAttribute('aria-expanded', 'false');
    clip.style.height = '';

    const runMeasure = function () {
      const computed = window.getComputedStyle(content);
      let lineHeight = parseFloat(computed.lineHeight);
      if (!lineHeight || Number.isNaN(lineHeight)) {
        lineHeight = parseFloat(computed.fontSize) * 1.2 || 16;
      }

      // Allow up to half a line of difference so trailing margins, descenders and
      // subpixel rounding inside the clamped box don't trigger the toggle when the
      // content actually has fewer lines than the truncate value.
      const tolerance = Math.max(1, lineHeight * 0.5);

      if (content.scrollHeight <= content.clientHeight + tolerance) {
        btn.hidden = true;
        root.classList.add('product-richtext-block--truncate-no-overflow');
        return;
      }

      btn.hidden = false;
      root.classList.remove('product-richtext-block--truncate-no-overflow');
    };

    requestAnimationFrame(runMeasure);
  }

  btn.addEventListener('click', function () {
    if (root.classList.contains('product-richtext-block--truncate-expanded')) {
      collapse();
    } else {
      expand();
    }
  });

  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(measure);
  } else {
    measure();
  }

  root._productRichtextRemeasure = measure;
}

function initAllProductRichtextTruncates(scope) {
  const container = scope && scope.querySelectorAll ? scope : document;
  container.querySelectorAll('.product-richtext-block--truncation-enabled[data-truncate-block]').forEach(function (root) {
    root.dataset.truncateInitialized = 'false';
    initProductRichtextTruncate(root);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function () {
    initAllProductRichtextTruncates();
  });
} else {
  initAllProductRichtextTruncates();
}

if (Shopify?.designMode) {
  document.addEventListener('shopify:section:load', function (event) {
    initAllProductRichtextTruncates(event.target);
  });
  document.addEventListener('shopify:block:select', function (event) {
    const root = event.target.closest('.product-richtext-block--truncation-enabled[data-truncate-block]');
    if (root && root._productRichtextRemeasure) {
      root._productRichtextRemeasure();
    }
  });
}
